import { render, staticRenderFns } from "./fitbInputSingleChoice.vue?vue&type=template&id=e0e90fda&"
import script from "./fitbInputSingleChoice.vue?vue&type=script&lang=js&"
export * from "./fitbInputSingleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports